import React from 'react'
import Video from '../assets/constructionZone-720p30.mp4'
import { TypeAnimation } from 'react-type-animation';

const HeroVideo = () => {
    return (
        <div className="video-container w-full h-screen">
            <div className="overlay absolute w-full h-full bg-[rgba(0,0,0,0.4)] left-0 top-0;"></div>
            <video className="w-full h-full object-cover" src={Video} autoPlay loop muted />
            <div className="content absolute w-full h-full flex flex-col justify-center text-center items-center font-xl text-orange-600 font-semibold top-0 mobile:py-40 font-sm">
                <TypeAnimation
                    sequence={[
                        'Welcome to Dian Cempaka',
                        1000, 
                        'We sell pipes for Air Conditioners',
                        1000,
                        'We sell pipes for Refrigerators',
                        1000,
                        'We sell pipes for Water Heaters',

                        1000
                    ]}
                    wrapper="span"
                    speed={50}
                    style={{ fontSize: '3em', display: 'inline-block', paddingRight: '10px' , paddingLeft: '10px' }}
                    repeat={Infinity}
                />
            </div>
        </div>
    )
}

export default HeroVideo;